import FilterProto from "./filter-field-proto";
import MultiselectFilter from "../../../gd-app/panels/filters-panel/filter-form/multiselect/multiselect";
import React from "react";

const debug = {
    dev: false
};

export default class FilterUserProto extends FilterProto {

    constructor(filtersManager, filterConfig, initValue, label) {
        super(filtersManager, filterConfig, initValue, label);
    }

    getFilterOptions() {

        const options = [];

        let users = [];
        [...this.optionsSet].map(userId => {
            const user = gd.session.users.get(userId);
            if (user) users.push(user);
        });

        // now order statuses
        users = _.sortBy(users,['name']);

        // add null options
        if (this.optionsSet.has(null)) {
            options.push({
                value: null,
                label: this.noOptionLabel
            })
        }

        // and create options
        users.map(user => {
            options.push({
                value: user.id,
                label: user.name,
                user: user
            })
        });
        return options;
    }

    // used only in Filter component
    getValue() {
        return this.value?this.value:[...this.optionsSet];
    }

    setValue(val, silent=false) {
        // reset value to null if all options selected
        if (!val || [...this.optionsSet].length == val.length) {
            val = null;
            this.isEnabled = false;
        } else {
            this.isEnabled = true;
        }

        super.setValue(val, silent);
    }

    render() {
        return <MultiselectFilter filter={this} />
    }


}